<!--a container for all of the different search components-->
<template>
  <div>
    <!-- Email filters -->
    <EmailSearchBar v-show="loading==false && activeView == 'search'" ref="searchBar" />
    <!-- Email filters -->
    <!-- detail content container -->
    <ItemDetail v-show="!loading && (activeView=='detail' || activeView=='persona-detail')"/>
    <!-- /detail container -->      
    
    <!-- main list view container -->
    <EmailList  v-show="!loading && resultsSearchType=='email' && activeView=='search' && viewType=='list'" ref="listView"/>

    <SmsList v-if="!loading && resultsSearchType=='sms' && activeView=='search' && viewType=='list'" ref="smsListView"/>

    <!-- journey view container -->
    <!-- using v-if because we don't want emails to load in background if we don't want to see them-->
    <JourneyView v-if="viewType=='journey'" ref="journeyView"/>

    <ResendEmail ref="resendEmail"/>
    <DeleteEmails ref="deleteEmails"/>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import EmailSearchBar from './search-bar'
import EmailList from './email-list'
import SmsList from './sms-list'
import ItemDetail from './item-detail'
import JourneyView from './journey-view'
import ResendEmail from './resend-email'
import DeleteEmails from '@/components/ui/delete-emails'

export default {
  components: {EmailSearchBar,EmailList,ItemDetail,SmsList,JourneyView,ResendEmail,DeleteEmails},
  computed: {
    ...mapState({
      uiConfig: (state)=>state.user.uiConfig,
      privs: (state)=>state.user.privs,
      emails: (state)=>state.search.emails,
      loading: (state)=>state.ui.loading,
      activeView: (state)=>state.ui.activeView,
      detailView: (state)=>state.ui.detailView,
      activeSubAccount: (state)=>state.ui.activeSubAccount,
      viewType: (state)=>state.ui.viewType,      
      selectedEmail: (state)=>state.search.selectedEmail,
      activeEmailSearch: (state)=>state.search.activeEmailSearch,
      emailsearchParams: (state)=>state.search.searchParams,
      filterEmail: (state)=>state.search.filterEmail,
      paginator: (state)=>state.search.paginator,
      resultsSearchType: (state)=>state.search.resultsSearchType,
      resend: (state)=>state.search.resend,      
    }),
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // access to component instance via `vm`
      vm.$store.commit("setActiveView","search");

      console.log("before enter search route")
      //this is a nuisance
      //vm.$refs.searchBar.doSearch();

    })
  },  
  methods:{
    deleteEmails() {
      this.$refs.deleteEmails.showDeleteEmails();
    },
  },
}  
</script>